import { makeStyles } from "tss-react/mui";
import { mdiChevronDown, mdiChevronUp } from "@mdi/js";
import { Box } from "@mui/material";
import { MiButton } from "../MiButton/MiButton";

export function MiReorderButton({
  onMoveUp,
  onMoveDown,
  disabled = false,
  disableUp = false,
  disableDown = false,
  disableRipple = false,
  orientation = "column",
}) {
  const { classes } = useStyles({ orientation });

  return (
    <Box className={classes.root}>
      <MiButton
        className={classes.orderBtn}
        startIcon={{
          path: mdiChevronUp,
          iconSize: 0.5,
          iconStyle: { stroke: "currentColor", strokeWidth: 2 },
        }}
        onClick={onMoveUp}
        disabled={disabled || disableUp}
        disableRipple={disableRipple}
      />
      <MiButton
        className={classes.orderBtn}
        startIcon={{
          path: mdiChevronDown,
          iconSize: 0.5,
          iconStyle: { stroke: "currentColor", strokeWidth: 2 },
        }}
        onClick={onMoveDown}
        disabled={disabled || disableDown}
        disableRipple={disableRipple}
      />
    </Box>
  );
}

const useStyles = makeStyles()((theme, { orientation }) => ({
  root: {
    display: "flex",
    flexDirection: orientation,
  },
  orderBtn: {
    padding: theme.spacing(0.5, 2),
    borderRadius: 4,
    "&:hover": {
      backgroundColor: theme.palette.grey.light,
    },
    transition: "background-color 0.3s ease",
  },
}));
